module.exports = __webpack_public_path__ + "img/桌卡1.6c11a46c.png";